import React, { useState, useEffect } from "react";
import { fetchHtmlPageByName } from "../../services/htmlPageService";

const Funding = () => {
  const [htmlContent, setHtmlContent] = useState("");
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const htmlPage = await fetchHtmlPageByName("funding");
        setHtmlContent(htmlPage.data.content);
      } catch (error) {
        console.error("Error fetching HTML page content:", error);
        setError("Failed to load content");
      } finally {
        setLoading(false);
      }
    };

    fetchContent(); // don't really need to set it up this way, however, will make itt easier to add more content later
  }, []);

  if (loading) return <div>Loading...</div>; // Display loading indicator
  if (error) return <div>{error}</div>; // Display error message if any

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-8">
          <img
            src={require("../../img/masthead4.png")}
            className="img-fluid text-center"
            alt="Young man and woman smiling"
          />
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </div>
      </div>
    </>
  );
};

export default Funding;
